/* eslint-disable react-hooks/exhaustive-deps */
// useApartment.ts
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useSite from './useSite';
import updateApartment, { UpdateApartmentInput } from './updateApartment';

/**
 * Usage:
 * const { mutate: update, isLoading, error } = useApartment();
 * update({ id: 'docId', data: { status: 'sold' } });
 *
 * By default uses current site/company from useSite().
 * Optionally override by passing company/site in the payload.
 */
export const useApartment = () => {
  const [site] = useSite();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (payload: Omit<UpdateApartmentInput, 'company' | 'site'>) => {
      if (!site.company || !site.siteid || !payload.id) {
        throw new Error('Missing company or site id.');
      }
      return updateApartment({
        company: site.company,
        site: site.siteid,
        id: payload.id,
        data: payload.data,
      });
    },
    onSuccess: () => {
      if (site?.siteid && site?.company)
        void qc.invalidateQueries({ queryKey: ['site', site.siteid, 'company', site.company, 'apartments'] });
    },
  });
};
